import _ from "lodash";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import TerminatedList from "@/Components/common/client/timesheet/TerminatedList";
import TimesheetTypes from "@/Components/common/client/timesheet/TimesheetTypes";
import { updateactivePages } from "@/reducers/clientcommon";
import { fetchTimesheetCount } from "@/reducers/timesheets/timesheets";
import {
  deSelectAllCandidate,
  fetchTerminatedTimesheets,
  setTerminatedTimesheetsLoading,
  updateFilters,
  updatePagination,
} from "@/reducers/timesheets/timesheetterminated";
import useTitle from "@/utilities/hooks/useTitle";

const Terminated = () => {
  useTitle("Terminated Timesheets");
  const { pagination } = useSelector(
    (state) => state.clientTimesheetTerminated,
  );
  const dispatch = useDispatch();
  const location = useLocation();
  useEffect(() => {
    const { state } = location;
    let filterObj = {};
    if (!_.isEmpty(state)) {
      filterObj = { ...filterObj, ...state };
      dispatch(updateFilters(filterObj));
    }
    dispatch(fetchTimesheetCount());
    dispatch(
      updatePagination({
        ...pagination,
        currentPage: 1,
        isLastPage: false,
      }),
    );
    dispatch(setTerminatedTimesheetsLoading(true));
    dispatch(deSelectAllCandidate());
    dispatch(fetchTerminatedTimesheets());
    dispatch(
      updateactivePages({
        activePage: "timesheets",
        activeSubPage: "disputed",
        callback: () => {
          if (!_.isEmpty(filterObj)) {
            dispatch(updateFilters(filterObj));
          }
        },
      }),
    );
  }, []);
  return (
    <div className="flex flex-col gap-4">
      <TimesheetTypes />
      <TerminatedList />
    </div>
  );
};

export default Terminated;
